import(/* webpackMode: "eager", webpackExports: ["TermsAndConditions"] */ "C:\\apps\\enginuity\\components\\legal.jsx");
